import { Injectable } from "@angular/core";
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ModelType, TireSize, ProviderLocation, Inventory, InventoryHistory } from '../models/loaner-wheel-inventory';
import { AppSettings } from "../../app.settings";

@Injectable()
export class LoanWheelInventoryService extends BaseService {

    constructor(private http: HttpClient,
        private config: AppSettings) {
        super();
    }

    getLoanerWheelSupplierConfig(supplierCode: string): Observable<boolean> {
        const url = `${this.config.BaseUrl}Profile/LoanerWheelInventory/GetLoanerWheelSupplierConfig/${supplierCode}`;
        return this.http.get<boolean>(url, { headers: this.setHeaders() })
            .pipe(map((r) => {
                return r
            }));
    }

    getModelType(): Observable<ModelType[]> {
        const url = `${this.config.BaseUrl}Profile/LoanerWheelInventory/ModelType`;
        return this.http.get<ModelType[]>(url, { headers: this.setHeaders() })
            .pipe(map((r) => {
                return r
            }));
    }

    getTireSize(): Observable<TireSize[]> {
        const url = `${this.config.BaseUrl}Profile/LoanerWheelInventory/TireSize`;
        return this.http.get<TireSize[]>(url, { headers: this.setHeaders() })
            .pipe(map((r) => {
                return r
            }));
    }

    getProviderLocations(supplierCode: string): Observable<ProviderLocation[]> {
        const url = `${this.config.BaseUrl}Profile/LoanerWheelInventory/GetProviderLocations/${supplierCode}`;
        return this.http.get<ProviderLocation[]>(url, { headers: this.setHeaders() })
            .pipe(map((r) => {
                return r
            }));
    }

    getInventoryBySupplier(supplierCode: string): Observable<Inventory[]> {
        const url = `${this.config.BaseUrl}Profile/LoanerWheelInventory/get/${supplierCode}`;
        return this.http.get<Inventory[]>(url, { headers: this.setHeaders() })
            .pipe(map((r) => {
                return r
            }));
    }

    setInventory(model: Inventory): Observable<Inventory> {
        const url = `${this.config.BaseUrl}Profile/LoanerWheelInventory/set`;
        return this.http.post<Inventory>(url, model, { headers: this.setHeaders() });
    }

    getInventoryHistoryBySupplier(supplierCode: string): Observable<InventoryHistory[]> {
        const url = `${this.config.BaseUrl}Profile/LoanerWheelInventory/get/${supplierCode}/history`;
        return this.http.get<InventoryHistory[]>(url, { headers: this.setHeaders() })
            .pipe(map((r) => {
                return r
            }));
    }
}
